import React, { Component } from "react";
import Button from "material-ui/Button";
import { withRouter } from "react-router";
import { withStyles } from "material-ui/styles";
import Searchbox from "../controls/Searchbox";
import api from "../../api";
import ApiAutoFetchDatagrid from "../controls/datagrid/ApiAutoFetchDatagrid";
import YesNo from "../controls/dialog/YesNo";
import CircularLoader from "../controls/loader/CircularLoader";
import Message from "../controls/Message";

const styles = theme => ({
  leftIcon: {
    marginRight: theme.spacing.unit
  },
  button: {
    margin: theme.spacing.unit
  },
  iconSmall: {
    fontSize: 20
  },
  wrapper: {
    marginTop: 20,
    position: "relative"
  }
});

class ProductTab extends Component {
  productColumns = [
    "ID",
    "Name",
    "Description",
    "Cost price",
    "Selling price",
    "Type",
    "Stock"
  ];

  state = {
    clearSearch: false,
    serachQuery: "",
    showConfirmDeleteDialog: false,
    isLoading: false,
    message: "",
    showMessage: false,
    isError: false
  };

  onListClick = () => {
    this.setState({ clearSearch: true, serachQuery: "", showMessage: false });
  };

  onSearchSubmit = async id => {
    this.setState({ clearSearch: false, serachQuery: id });
  };

  onCreateNewClick = () => {
    this.props.history.push("products/new");
  };

  onEdit = row => {
    this.props.history.push(`products/edit/${row.id}`);
  };

  onStock = async row => {
    const quantity = window.prompt(
      `Enter stock quantity to add for "${row.name}":`
    );

    if (quantity === null) {
      return;
    }

    const parsedQuantity = Number(quantity);

    if (!Number.isFinite(parsedQuantity) || parsedQuantity <= 0) {
      this.showMessage("Please enter a valid stock quantity greater than 0.", true);
      return;
    }

    try {
      this.setState({ isLoading: true });

      const res = await api.posProduct.addStock(
        row.id,
        parsedQuantity
      );

      if (res.status === 200) {
        this.setState({
          clearSearch: true,
          serachQuery: ""
        });

        this.showMessage(
          `Stock added successfully. New stock: ${res.data.stockQuantity}`
        );
      } else {
        throw new Error(
          `Couldn't add stock. The status code is ${res.status}`
        );
      }
    } catch (error) {
      this.showMessage(
        error.response &&
        error.response.data &&
        error.response.data.message
          ? error.response.data.message
          : error.message,
        true
      );
    }
  };

  onDelete = itemToDelete => {
    this.setState({ showConfirmDeleteDialog: true, itemToDelete });
  };

  onConfirmDeleteClick = async () => {
    const { id } = this.state.itemToDelete;

    try {
      this.setState({ isLoading: true });

      const res = await api.posProduct.delete(id);

      if (res.status === 200) {
        this.showMessage("Deleted successfully.");
      } else {
        throw new Error(
          `Couldn't delete the record. The status code is ${res.status}`
        );
      }
    } catch (error) {
      this.showMessage(error.message, true);
    }
  };

  onMessageCloseClick = () => {
    this.setState({ showMessage: false });
  };

  onCancelConfirmDeleteClick = () => {
    this.setState({ showConfirmDeleteDialog: false });
  };

  showMessage = (message, isError = false) => {
    this.setState({
      showMessage: true,
      isError,
      message,
      isLoading: false,
      showConfirmDeleteDialog: false
    });
  };

  getApiPromise = () => {
    const { serachQuery } = this.state;

    if (serachQuery.length === 0) {
      return api.posProduct.fetchByPages();
    }

    return api.posProduct.searchByIdAndGetByPages(serachQuery);
  };

  render() {
    const {
      clearSearch,
      showConfirmDeleteDialog,
      isLoading,
      message,
      showMessage,
      isError
    } = this.state;
    const { classes } = this.props;

    return (
      <div className={classes.wrapper}>
        <CircularLoader isLoading={isLoading} />
        <YesNo
          open={showConfirmDeleteDialog}
          message="Are you sure wan't to delete the selected item"
          onOk={this.onConfirmDeleteClick}
          onCancel={this.onCancelConfirmDeleteClick}
        />
        <div>
          <Button
            className={classes.button}
            variant="raised"
            color="default"
            size="small"
            onClick={this.onListClick}
          >
            List
          </Button>

          <Button
            className={classes.button}
            variant="raised"
            color="primary"
            size="small"
            onClick={this.onCreateNewClick}
          >
            Create New
          </Button>
          <Searchbox
            clear={clearSearch}
            onChange={this.onSearchChange}
            onSubmit={this.onSearchSubmit}
          />
        </div>

        <Message
          style={{ width: "98%" }}
          title="Message"
          message={message}
          show={showMessage}
          isError={isError}
          onCloseClick={this.onMessageCloseClick}
          autoClose={!isError}
        />

        <div className={classes.wrapper}>
          <ApiAutoFetchDatagrid
            datasourcePromise={this.getApiPromise}
            actions={["stock", "del", "edit"]}
            onEdit={this.onEdit}
            onDelete={this.onDelete}
            onStock={this.onStock}
            headers={this.productColumns}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(ProductTab));



